import {
  StaggerReveal,
  MotionItem,
  fadeUp,
  fadeUpSmall,
  scaleIn,
} from "../components/ui/Motion";
import {
  NotFoundWrap,
  Inner,
  Eyebrow,
  ErrorCode,
  Title,
  Description,
  Actions,
  PrimaryButton,
  SecondaryButton,
} from "./styles/NotFoundPage.styles";

function NotFoundPage() {
  return (
    <NotFoundWrap>
      <Inner>
        <StaggerReveal>
          <MotionItem $variants={fadeUpSmall}>
            <Eyebrow>Error 404</Eyebrow>
          </MotionItem>
          <MotionItem $variants={scaleIn}>
            <ErrorCode>404</ErrorCode>
          </MotionItem>
          <MotionItem $variants={fadeUp}>
            <Title>
              Lost at <em>Sea</em>
            </Title>
          </MotionItem>
          <MotionItem $variants={fadeUpSmall}>
            <Description>
              The page you're looking for has drifted off course or never existed.
              Let's get you back to safer waters.
            </Description>
          </MotionItem>
          <MotionItem $variants={fadeUpSmall}>
            <Actions>
              <PrimaryButton to="/">Back to Home</PrimaryButton>
              <SecondaryButton to="/yachts">Browse Yachts</SecondaryButton>
            </Actions>
          </MotionItem>
        </StaggerReveal>
      </Inner>
    </NotFoundWrap>
  );
}

export default NotFoundPage;
